module.exports = __webpack_public_path__ + "static/media/equipments-bg.c56b5b34.jpg";